import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import IssueTab from 'containers/data/Issue';
import Intro from 'components/common/Intro';
import ToolsBar from 'components/common/ToolsBar';
import Tabs from 'components/common/Tabs';
import Footer from 'components/common/Footer';
import * as options from 'constants/SelectsOptions';
import { roundNumber, isValidNumber } from 'utils/general';

class DataPage extends React.Component {
  constructor() {
    super();
    this.handleSectorChange = this.handleSectorChange.bind(this);
    this.handleDisplayChange = this.handleDisplayChange.bind(this);
    this.onDownload = this.onDownload.bind(this);
    this.addCsvYearData = this.addCsvYearData.bind(this);
  }

  componentWillMount() {
    this.props.setSector(this.props.routeParams.sector);
  }

  onDownload() {
    function getFormattedName(name) {
      if (!name || !name.length) return name;
      const valueArray = String(name).split('');
      const startParanthesisLength = valueArray.filter(e => e === '(').length;
      const endParanthesisLength = valueArray.filter(e => e === ')').length;
      if (startParanthesisLength !== endParanthesisLength) return name;
      let newNameArray = valueArray.slice();
      let startingArray = valueArray.slice();
      let incOffset = 0;
      for (let i = 0; i < valueArray.length; i++) {
        const startIndex = startingArray.findIndex(el => el === '(');
        const endIndex = startingArray.findIndex(el => el === ')');
        if (startIndex >= 0 && endIndex >= 0 && startIndex <= endIndex) {
          const sectorName = startingArray.slice(startIndex + 1, endIndex).join('');
          if (sectorName && ((sectorName.includes('oil') && sectorName.includes('gas')) || sectorName.includes('mining'))) {
            newNameArray = [...valueArray.slice(0, startIndex + incOffset), ...valueArray.slice(endIndex + incOffset + 1)];
            break;
          } else {
            incOffset = incOffset + endIndex + 1;
            startingArray = valueArray.slice(endIndex + 1);
          }
        }
      }
      return newNameArray.join('');
    }
    const { filteredData, filters } = this.props;
    const { years } = filters || {};
    const { category, subcategory, indicator } = this.getFiltersNames();
    const validYears = years.filter(y => !!y);
    let csvContent = '';
    if (!navigator.msSaveBlob) csvContent += 'data:text/csv;charset=utf-8,';
    csvContent += `name,sector,region,Composite/component,Subcomponent,Indicator${this.addCsvYearData(null, validYears || [], true)}\n`;
    filteredData.forEach((cs, i) => {
      const region = cs.region.join('-');
      const dataString = `${getFormattedName(cs.name)},${cs.sector},${region},${category},${subcategory},${indicator}${this.addCsvYearData(cs, validYears || [], false)}`;
      csvContent += i < filteredData.length ? `${dataString}\n` : dataString;
    });

    if (navigator.msSaveBlob) { // IE 10+
      navigator.msSaveBlob(new Blob([csvContent], { type: 'text/csv;charset=utf-8;' }), 'nrgi_data.csv');
    } else {
      const encodedUri = encodeURI(csvContent);
      const link = document.createElement('a');
      link.setAttribute('href', encodedUri);
      link.setAttribute('download', 'nrgi_data.csv');
      document.body.appendChild(link); // Required for FF

      link.click();
    }
  }

  getFiltersNames() {
    const category = document.querySelectorAll('.category-select .Select-value-label');
    const subcategory = document.querySelectorAll('.subcategory-select .Select-value-label');
    const indicator = document.querySelectorAll('.indicator-select .Select-value-label');

    return {
      category: category.length ? category[0].innerHTML : '',
      subcategory: subcategory.length ? subcategory[0].innerHTML : '',
      indicator: indicator.length ? indicator[0].innerHTML : ''
    };
  }

  addCsvYearData(scoreData, years, addHeader = false) {
    if (addHeader) {
      return `,${years.map(y => `Score${y}`).join(',')}`;
    }
    return `,${years.map(y => isValidNumber(scoreData[`score${y}`]) ? roundNumber(scoreData[`score${y}`]) : '').join(',')}`;
  }

  handleSectorChange(option) {
    const display = this.props.router.params.displayBy;
    const search = this.props.router.getCurrentLocation().search;
    this.props.router.push(`/data/${option.value}/${display}${search}`);
    this.props.setSector(option.value);
  }

  handleDisplayChange(option) {
    const sector = this.props.router.params.sector;
    const search = this.props.router.getCurrentLocation().search;
    this.props.router.push(`/data/${sector}/${option.value}${search}`);
  }

  render() {
    return (
      <div className="l-main">
        <Intro section="data" theme={this.props.router.params.sector}>
          <ToolsBar setModalContent={this.props.setModalContent} downloadText="Download data" onDownload={this.onDownload} />
          <div className="row">
            <div className="column small-12 medium-small-7 medium-6 section">
              <h1 className="title -section-title -light">Data</h1>
              <p className="-light">
                Explore the index results from composite down to indicator level; filter by sector and geographical grouping.
              </p>
              <Tabs
                value={this.props.filters.sector}
                options={options.sectors}
                onChange={this.handleSectorChange}
                theme={this.props.router.params.sector}
              />
            </div>
          </div>
        </Intro>
        <IssueTab filters={this.props.filters} theme={this.props.routeParams.sector} />
        <Footer />
      </div>
    );
  }
}

DataPage.propTypes = {
  theme: PropTypes.string,
  routeParams: PropTypes.object,
  filteredData: PropTypes.array,
  filters: PropTypes.object.isRequired,
  setModalContent: PropTypes.func,
  setSector: PropTypes.func,
  router: PropTypes.object.isRequired
};

export default withRouter(DataPage);



// WEBPACK FOOTER //
// ./app/components/data/index.jsx